/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { EnhanceSpeechTrack } from "components/EnhancedSpeech/EnhanceSpeechTrack";

export const enum ProcessingState {
  uploading,
  queued,
  paused,
  processing,
  finished,
}

export interface EnhancementObject {
  track: EnhanceSpeechTrack;
  enhancedTrackName: string;
  processingState: ProcessingState;
  isDeleting: boolean;
  delete: () => Promise<void>;
  percentUploaded?: number;
}

export interface SampleEnhancementObject extends EnhancementObject {
  isSample: true;
}
